import { useEffect, useRef } from 'react';

const useRefChangeWatcher = (ref, cb) => {
  const previous = useRef(null);

  useEffect(() => {
    if (previous.current !== ref.current) {
      previous.current = ref.current;
      cb(ref.current);
    }
  });
};

export default useRefChangeWatcher;
